import { Col, Form, Input } from "antd";
import { FC, useEffect, useState } from "react";
import { MazakaInputProps } from "models/Client/MazakaInputModel";

export const MazakaPassword: FC<MazakaInputProps> = (props) => {
  const [showPass, setShowPass] = useState<boolean | undefined>(true);
  const [password, setPassword] = useState<string>("");
  const [validations, setValidations] = useState({
    hasLowercase: false,
    hasUppercase: false,
    hasNumber: false,
    isMinLength: false,
  });

  useEffect(() => {
    if (props.hasOwnProperty("isShowDescriptionPass")) {
      setShowPass(props.isShowDescriptionPass);
    }
  }, [props?.isShowDescriptionPass]);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPassword(value);

    setValidations({
      hasLowercase: /[a-z]/.test(value),
      hasUppercase: /[A-Z]/.test(value),
      hasNumber: /\d/.test(value),
      isMinLength: value.length >= 6,
    });
  };

  const getColor = (isValid: boolean) => {
    return password.length === 0 ? "text-[#656464]" : isValid ? "text-green-500" : "text-red-500";
  };

  const resetPassword = () => {
    setPassword(""); 
    setValidations({
      hasLowercase: false,
      hasUppercase: false,
      hasNumber: false,
      isMinLength: false,
    }); 
    props.setIsResetPassValidation(false)
   
  };

  useEffect(()=>{
    if(props.isResetPassValidation)
    {
      resetPassword()
    }
  },[props.isResetPassValidation])

  return (
    <Col span={props.span ?? 24} xl={props.xl} lg={props.lg} xs={props.xs} md={props.md}>
      <Form.Item
        className={props.className}
        name={props.name}
        initialValue={props.initialValue}
        rules={[
          { required: props.required || true, message: "Şifre gereklidir" },
          { 
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/, 
            message: "Şifre kriterlere uygun değil" 
          },
        ]}
        label={props.label}
        colon={props.colon}
        labelAlign={props.labelAlign}
        labelCol={props.labelCol}
        wrapperCol={props.wrapperCol}
        hasFeedback={props.hasFeedback}
      >
        <Input.Password
          className={`rounded ${props.inputClassName}`}
          onBlur={props.onBlur}
          onChange={(e) => {
            handlePasswordChange(e);
            props.onChange?.(e); 
          }}
          prefix={props?.prefix}
          suffix={props?.suffix}
          disabled={props?.disabled}
          min={props.min}
          max={props.max}
          type={props?.type}
          placeholder={`${props.placeholder ?? "••••••••"}`}
        />
      </Form.Item>

      {showPass && props.isShowDescriptionPass && (
        <div className="!mt-2">
          <p className={`!text-xs ${getColor(validations.hasLowercase)}`}>
            1. En az bir küçük harf bulunmalıdır
          </p>
          <p className={`!text-xs ${getColor(validations.hasUppercase)}`}>
            2. En az bir büyük harf bulunmalıdır.
          </p>
          <p className={`!text-xs ${getColor(validations.hasNumber)}`}>
            3. En az bir rakam bulunmalıdır.
          </p>
          <p className={`!text-xs ${getColor(validations.isMinLength)}`}>
            4. Toplamda en az 6 karakter olmalıdır.
          </p>
        </div>
      )}
    </Col>
  );
};
